import React from 'react';
export const HowItWorks = () => {
  return <section id="how-it-works" className="py-20 bg-gray-50 relative overflow-hidden" data-id="element-368">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1523438885200-e635ba2c371e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] opacity-5 bg-fixed" data-id="element-369"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-370">
        <div className="text-center mb-16" data-id="element-371">
          <span className="inline-block px-4 py-1 bg-limestone-200 text-limestone-700 rounded-full text-sm font-medium mb-4" data-id="element-372">
            YOUR JOURNEY
          </span>
          <h2 className="text-4xl font-serif font-bold mb-4 text-gray-800" data-id="element-373">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-374">
            Your journey to becoming an Elite Planners Association member is
            just 4 steps away.
          </p>
        </div>
        <div className="max-w-6xl mx-auto" data-id="element-375">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-376">
            {/* Step 1 */}
            <div className="relative bg-white rounded-xl shadow-xl p-8 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl group" data-id="element-377">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-limestone-700 text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold z-10" data-id="element-378">
                1
              </div>
              <div className="pt-6" data-id="element-379">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 text-center" data-id="element-380">
                  Application
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-381">
                  Submit your application for membership. Our committee reviews
                  each application carefully to ensure all members meet our
                  quality standards.
                </p>
                <div className="bg-limestone-50 rounded-lg p-4 border border-limestone-100" data-id="element-382">
                  <p className="text-sm italic text-gray-700" data-id="element-383">
                    "We carefully review each application to ensure our
                    community consists of top-tier planners who share our values
                    of excellence and collaboration."
                  </p>
                  <div className="mt-2 text-sm font-medium text-limestone-700" data-id="element-384">
                    — Membership Committee
                  </div>
                </div>
              </div>
            </div>
            {/* Step 2 */}
            <div className="relative bg-white rounded-xl shadow-xl p-8 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl group" data-id="element-385">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-limestone-700 text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold z-10" data-id="element-386">
                2
              </div>
              <div className="pt-6" data-id="element-387">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 text-center" data-id="element-388">
                  Onboarding
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-389">
                  Once accepted, our team will guide you through the onboarding
                  process, introducing you to our platform, resources, and
                  community.
                </p>
                <div className="bg-limestone-50 rounded-lg p-4 border border-limestone-100" data-id="element-390">
                  <p className="text-sm italic text-gray-700" data-id="element-391">
                    "Our onboarding process is designed to quickly integrate you
                    into our community and help you start benefiting from
                    membership immediately."
                  </p>
                  <div className="mt-2 text-sm font-medium text-limestone-700" data-id="element-392">
                    — Onboarding Team
                  </div>
                </div>
              </div>
            </div>
            {/* Step 3 */}
            <div className="relative bg-white rounded-xl shadow-xl p-8 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl group" data-id="element-393">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-limestone-700 text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold z-10" data-id="element-394">
                3
              </div>
              <div className="pt-6" data-id="element-395">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 text-center" data-id="element-396">
                  Integration
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-397">
                  Connect your existing tools and workflows with our platform.
                  Set up your profile and start engaging with other members.
                </p>
                <div className="bg-limestone-50 rounded-lg p-4 border border-limestone-100" data-id="element-398">
                  <p className="text-sm italic text-gray-700" data-id="element-399">
                    "Our technical team ensures a seamless integration with your
                    existing business systems so you can hit the ground
                    running."
                  </p>
                  <div className="mt-2 text-sm font-medium text-limestone-700" data-id="element-400">
                    — Technical Support
                  </div>
                </div>
              </div>
            </div>
            {/* Step 4 */}
            <div className="relative bg-white rounded-xl shadow-xl p-8 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl group" data-id="element-401">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-limestone-700 text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold z-10" data-id="element-402">
                4
              </div>
              <div className="pt-6" data-id="element-403">
                <h3 className="text-2xl font-bold mb-4 text-gray-800 text-center" data-id="element-404">
                  Success
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-405">
                  Start leveraging your membership benefits, accessing exclusive
                  resources, and growing your business with our support.
                </p>
                <div className="bg-limestone-50 rounded-lg p-4 border border-limestone-100" data-id="element-406">
                  <p className="text-sm italic text-gray-700" data-id="element-407">
                    "From day one, you'll start experiencing the benefits of
                    being part of the most exclusive wedding planner network in
                    the industry."
                  </p>
                  <div className="mt-2 text-sm font-medium text-limestone-700" data-id="element-408">
                    — Member Success Team
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-32 text-center" data-id="element-409">
          <button className="bg-limestone-700 hover:bg-limestone-800 text-white font-bold py-3 px-8 rounded-lg text-lg transition transform hover:scale-105 shadow-lg" data-id="element-410">
            Start Your Journey
          </button>
        </div>
      </div>
    </section>;
};